<template>
  <keep-alive>
    <b-form-group
      :label="formLabel"
      :description="descVal"
      class="text-capitalize"
      :state="state"
      :invalid-feedback="invalidFeedback">
      <b-input-group class="mb-2">
        <b-input-group-prepend
          v-if="prepend"
          is-text>
          <b-checkbox
            size="sm"
            switch />
        </b-input-group-prepend>
        <component
          :is="type === `textarea` ? `b-form-textarea` : `b-form-input`"
          :id="`input-${device}-${configKey}`"
          v-model="config[configKey]"
          :state="state"
          :maxlength="charMax"
          :placeholder="placeholder"
          :required="required"
          :class="{'pb-3': configKey === `text`}"
          trim
          @focus="focused = true"
          @blur="blurring()" />
      </b-input-group>
    </b-form-group>
  </keep-alive>
</template>

<script>

export default {
  name: "PaywallFormInput",
  props: {
    config: {
      type: Object,
      required: true,
    },
    configKey: {
      type: String,
      required: true,
    },
    charMax: {
      type: Number,
      default: 200,
      required: false,
    },
    device: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    required: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: null,
    },
    type: {
      type: String,
      default: "text",
    },
    description: {
      type: String,
      default: null,
    },
    prepend: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      initialInput: this.inputVal,
      delta: false,
      focused: false,
    }
  },
  computed: {
    state() {
      if (this.delta && this.required && !this.focused) {
        const inputLen = this.inputVal.length
        return inputLen > 0 && inputLen <= this.charMax
      }
      return null
    },
    inputVal() {
      return this.config[this.configKey] ? this.config[this.configKey] : ""
    },
    invalidFeedback() {
      return `${this.configKey} is required`
    },
    formLabel() {
      return this.required ? `* ${this.label}` : this.label
    },
    descVal() {
      const inputLen = this.inputVal.length

      if (this.focused && this.inputVal !== this.initialInput) {
        if (this.description) return this.description

        if (inputLen > 0 && inputLen < this.charMax) {
          return `${inputLen} characters`
        } else if(inputLen === this.charMax) {
          return `cannot exceed ${this.charMax} characters`
        }
      }
      return ''
    },
  },
  methods: {
    blurring() {
      this.focused = false
      this.delta = this.config[this.configKey] !== this.initialInput
    },
  },
}
</script>

<style scoped>

</style>
